type TrackFormViewInput = {
  id: string;
  event: "view" | "start" | "submit";
};

const trackFormHandler = ({ id, event }: TrackFormViewInput) => {
  return fetch("/api/tracking/forms/t", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, event }),
  }).then((res: any) => res.json());
};

const useFormAnalytics = () => {
  const trackFormEvent = ({ id, event }: TrackFormViewInput) => {
    trackFormHandler({ id, event });
  };
  return { trackFormEvent };
};

export default useFormAnalytics;
